import { createFileRoute, useParams } from "@tanstack/react-router";
import { AssetTypeAccessSection } from "@/utils/asset-type-detail/asset-type-access-section";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/access",
)({
	component: OrgAssetTypeAccessTab,
});

function OrgAssetTypeAccessTab() {
	const { orgId } = useParams({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/access",
	});

	return (
		<div className="px-5 pb-5">
			<AssetTypeAccessSection orgId={orgId} />
		</div>
	);
}
